import { put, call } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as actions from '../actions/processing';
import { post } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';
import { getShipmentUpdate } from '../actions/shipment';

export function* getProcessingStart({ payload }) {
  try {
    yield call(post,
      '/action/processing/start',
      {
        plantId: Number(payload.plantId),
        items: payload.items
      });
    yield put(actions.getProcessingStartSuccess());
    yield put(getShipmentUpdate());
  } catch (error) {
    yield put(actions.getProcessingStartFail());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
  }
}

export function* getProcessingStartCancel({ payload }) {
  try {
    yield call(post,
      '/action/processing/start_cancel',
      {
        plantId: Number(payload.plantId),
        items: payload.items
      });
    yield put(actions.getProcessingStartCancelSuccess());
    yield put(getShipmentUpdate());
    yield put(actions.getProcessingStartClear());
  } catch (error) {
    yield put(actions.getProcessingStartCancelFail());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
  }
}

export function* getAwaitingProcessingStart({ payload }) {
  try {
    yield call(post,
      '/action/processing/awaiting_start',
      {
        plantId: Number(payload.plantId),
        dateProcessing: payload.dateProcessing,
        items: payload.items
      });
    yield put(actions.getAwaitingProcessingStartSuccess());
    yield put(getShipmentUpdate());
  } catch (error) {
    yield put(actions.getAwaitingProcessingStartFail());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
  }
}
